/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListMyInvitationsQueryResponse, ListMyInvitations400, ListMyInvitations401, ListMyInvitations403, ListMyInvitations404, ListMyInvitations409, ListMyInvitations500 } from "../../types/staffController/ListMyInvitations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listMyInvitations } from "../../client/staffController/listMyInvitations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listMyInvitationsQueryKey = () => [{ url: '/api/invitations/me' }] as const

export type ListMyInvitationsQueryKey = ReturnType<typeof listMyInvitationsQueryKey>

export function listMyInvitationsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listMyInvitationsQueryKey()
        return queryOptions<ListMyInvitationsQueryResponse, ResponseErrorConfig<ListMyInvitations400 | ListMyInvitations401 | ListMyInvitations403 | ListMyInvitations404 | ListMyInvitations409 | ListMyInvitations500>, ListMyInvitationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listMyInvitations({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the signed-in user's pending invitations
 * {@link /api/invitations/me}
 */
export function useListMyInvitations<TData = ListMyInvitationsQueryResponse, TQueryData = ListMyInvitationsQueryResponse, TQueryKey extends QueryKey = ListMyInvitationsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ListMyInvitationsQueryResponse, ResponseErrorConfig<ListMyInvitations400 | ListMyInvitations401 | ListMyInvitations403 | ListMyInvitations404 | ListMyInvitations409 | ListMyInvitations500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listMyInvitationsQueryKey()
         

         const query = useQuery({
          ...listMyInvitationsQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListMyInvitations400 | ListMyInvitations401 | ListMyInvitations403 | ListMyInvitations404 | ListMyInvitations409 | ListMyInvitations500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}